// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlogsMain_main__eyM2i {
    background-color: #1a1a1a;
  }
  
  .BlogsMain_heroSection__sF2p1 {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    margin-bottom: 40px;
}

  
.BlogsMain_heroImage__K9JFS {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.BlogsMain_heroOverlay__f-tUX {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5%;
  color: white;
  background: 
  linear-gradient(
    to top,
    rgba(26, 26, 26, 0.6) 0%,
    rgba(26, 26, 26, 0) 10%
  ),
  linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.4) 55%,
    rgba(0, 0, 0, 0) 80%,
    #1a1a1a 100%
  );
}

.BlogsMain_heroContent__\\+mP8s {
  max-width: 600px;
}

.BlogsMain_heroTitle__XY7d9 {
  font-family: 'Medula One', cursive;
  font-weight: 500;
  font-size: 90px;
  margin-bottom: 1rem;
  line-height: 120px;
}

.BlogsMain_heroDescription__vMmF1 {
  font-size: 12px;
  margin-bottom: 10px;
}

.BlogsMain_readMoreButton__\\+9h4T {
  padding: 12px 24px;
  background-color: #dc143c; /* Crimson red */
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  text-transform: uppercase;
  font-weight: bold;
}

.BlogsMain_readMoreButton__\\+9h4T:hover {
  background-color: #8b0000; /* Dark red on hover */
}

.BlogsMain_heroSwiper__\\+95rH {
  width: 100%;
  height: 100%;
}

.BlogsMain_heroSwiperSlide__deRJE {
  width: 100%;
  height: 100%;
}
.BlogsMain_blogSection__PWLeh {
  max-width: 95%;
  margin: 0 auto;
  padding: 1rem 2rem;
}
  
.BlogsMain_sectionTitle__Z5pfJ {
  color: white;
  font-size: 2rem;
  margin-top: 0rem;
  margin-bottom: 1rem;
}

.BlogsMain_cardContainer__8N7ZN {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}
/* Responsive Styles */
@media (max-width: 820px) {
  .BlogsMain_heroSection__sF2p1 {
    height: 300px;
  }

  .BlogsMain_heroTitle__XY7d9 {
    font-size: 1.8rem;
  }

  .BlogsMain_heroDescription__vMmF1 {
    font-size: 1rem;
  }

  .BlogsMain_readMoreButton__\\+9h4T {
    padding: 10px 20px;
  }
  .BlogsMain_heroSection__sF2p1 {
    height: 45vh;
  }
  .BlogsMain_heroSection__sF2p1 {
    height: 45vh;
  }
}

@media (max-width: 480px) {
  .BlogsMain_heroSection__sF2p1 {
    height: 250px;
  }

  .BlogsMain_heroTitle__XY7d9 {
    font-weight: 500;
    font-size: 50px;
    line-height: 65px;
  }

  .BlogsMain_heroDescription__vMmF1 {
    font-size: 0.9rem;
    margin-bottom: 20px;
  }

  .BlogsMain_blogSection__PWLeh {
    padding: 0;
  }

  .BlogsMain_sectionTitle__Z5pfJ {
    font-size: 18px;
    margin-bottom: 0rem;
  }
  .BlogsMain_heroTitle__XY7d9 {
    margin-bottom: 0px;
  }
  .BlogsMain_heroContent__\\+mP8s {
    text-align: center;
  }
}
  
  @media (max-width: 768px) {
    .BlogsMain_cardContainer__8N7ZN {
      grid-template-columns: 1fr;
    }

  }`, "",{"version":3,"sources":["webpack://./src/Blogs/Components/CSS/BlogsMain.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ;;;;;;;;;;;GAWC;AACH;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,gBAAgB;EAC3C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF;;EAEE;IACE;MACE,0BAA0B;IAC5B;;EAEF","sourcesContent":[".main {\n    background-color: #1a1a1a;\n  }\n  \n  .heroSection {\n    position: relative;\n    width: 100%;\n    height: 100vh;\n    overflow: hidden;\n    margin-bottom: 40px;\n}\n\n  \n.heroImage {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.heroOverlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0 5%;\n  color: white;\n  background: \n  linear-gradient(\n    to top,\n    rgba(26, 26, 26, 0.6) 0%,\n    rgba(26, 26, 26, 0) 10%\n  ),\n  linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.4) 55%,\n    rgba(0, 0, 0, 0) 80%,\n    #1a1a1a 100%\n  );\n}\n\n.heroContent {\n  max-width: 600px;\n}\n\n.heroTitle {\n  font-family: 'Medula One', cursive;\n  font-weight: 500;\n  font-size: 90px;\n  margin-bottom: 1rem;\n  line-height: 120px;\n}\n\n.heroDescription {\n  font-size: 12px;\n  margin-bottom: 10px;\n}\n\n.readMoreButton {\n  padding: 12px 24px;\n  background-color: #dc143c; /* Crimson red */\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  text-transform: uppercase;\n  font-weight: bold;\n}\n\n.readMoreButton:hover {\n  background-color: #8b0000; /* Dark red on hover */\n}\n\n.heroSwiper {\n  width: 100%;\n  height: 100%;\n}\n\n.heroSwiperSlide {\n  width: 100%;\n  height: 100%;\n}\n.blogSection {\n  max-width: 95%;\n  margin: 0 auto;\n  padding: 1rem 2rem;\n}\n  \n.sectionTitle {\n  color: white;\n  font-size: 2rem;\n  margin-top: 0rem;\n  margin-bottom: 1rem;\n}\n\n.cardContainer {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 2rem;\n}\n/* Responsive Styles */\n@media (max-width: 820px) {\n  .heroSection {\n    height: 300px;\n  }\n\n  .heroTitle {\n    font-size: 1.8rem;\n  }\n\n  .heroDescription {\n    font-size: 1rem;\n  }\n\n  .readMoreButton {\n    padding: 10px 20px;\n  }\n  .heroSection {\n    height: 45vh;\n  }\n  .heroSection {\n    height: 45vh;\n  }\n}\n\n@media (max-width: 480px) {\n  .heroSection {\n    height: 250px;\n  }\n\n  .heroTitle {\n    font-weight: 500;\n    font-size: 50px;\n    line-height: 65px;\n  }\n\n  .heroDescription {\n    font-size: 0.9rem;\n    margin-bottom: 20px;\n  }\n\n  .blogSection {\n    padding: 0;\n  }\n\n  .sectionTitle {\n    font-size: 18px;\n    margin-bottom: 0rem;\n  }\n  .heroTitle {\n    margin-bottom: 0px;\n  }\n  .heroContent {\n    text-align: center;\n  }\n}\n  \n  @media (max-width: 768px) {\n    .cardContainer {\n      grid-template-columns: 1fr;\n    }\n\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `BlogsMain_main__eyM2i`,
	"heroSection": `BlogsMain_heroSection__sF2p1`,
	"heroImage": `BlogsMain_heroImage__K9JFS`,
	"heroOverlay": `BlogsMain_heroOverlay__f-tUX`,
	"heroContent": `BlogsMain_heroContent__+mP8s`,
	"heroTitle": `BlogsMain_heroTitle__XY7d9`,
	"heroDescription": `BlogsMain_heroDescription__vMmF1`,
	"readMoreButton": `BlogsMain_readMoreButton__+9h4T`,
	"heroSwiper": `BlogsMain_heroSwiper__+95rH`,
	"heroSwiperSlide": `BlogsMain_heroSwiperSlide__deRJE`,
	"blogSection": `BlogsMain_blogSection__PWLeh`,
	"sectionTitle": `BlogsMain_sectionTitle__Z5pfJ`,
	"cardContainer": `BlogsMain_cardContainer__8N7ZN`
};
export default ___CSS_LOADER_EXPORT___;
